import { Injectable } from '@angular/core';
import { HttpGeneralService, OutpatientParms } from '../../shared';
import { CONFIG } from '../../shared/config';
import { EmrPatientParms } from '../medical-recored.interfaces';

let ApiUrl = CONFIG.baseUrls.emrSheets;
let emrChartsUrl = CONFIG.baseUrls.emrCharts;

@Injectable({
  providedIn: 'root'
})
export class EmrPatAllVisitsService {

  constructor(private httpGeneralService: HttpGeneralService) { }

  getAllPatientVisits(data: OutpatientParms) {
    return this.httpGeneralService.post(data, `${ApiUrl}/getEmrAllPatVisits`);
  }
  
  getEmrDoctorsData(PatientParms: EmrPatientParms) {
    return this.httpGeneralService.add(PatientParms, `${emrChartsUrl}/getDoctorsData`);
  }
  getAllPatientVisitsHestory(data: OutpatientParms) {
    return this.httpGeneralService.post(data, `${ApiUrl}/getEmrAllPatVisitsHestory`);
  }
}
